import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { logout } from "features/auth/authSlice";
import { clearNotification } from "features/notificationSlice";
import { resetTopFolderZip } from "features/topFolderZipSlice";
import { resetBrowserZip } from "features/browserZipSlice";
import { clearTopFolderZipStorage } from "features/topFolderZipPersistence";
import { clearBrowserZipStorage } from "features/browserZipPersistence";
import { api } from "features/api";
import { apiWithAuth } from "features/auth/auth";

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(
    logout.match,
    apiWithAuth.endpoints.logout.matchFulfilled,
    apiWithAuth.endpoints.login.matchFulfilled,
    apiWithAuth.endpoints.checkAuth.matchRejected
  ),
  effect: async (action, listenerApi) => {
    if (logout.match(action)) {
      listenerApi.dispatch(api.util.resetApiState());
      sessionStorage.removeItem("setEmailPromptDismissed");
      listenerApi.dispatch(resetTopFolderZip());
      listenerApi.dispatch(resetBrowserZip());
      clearTopFolderZipStorage();
      clearBrowserZipStorage();
    }
    if (apiWithAuth.endpoints.logout.matchFulfilled(action)) {
      sessionStorage.removeItem("setEmailPromptDismissed");
      listenerApi.dispatch(resetTopFolderZip());
      listenerApi.dispatch(resetBrowserZip());
      clearTopFolderZipStorage();
      clearBrowserZipStorage();
    }
    if (apiWithAuth.endpoints.checkAuth.matchRejected(action)) {
      sessionStorage.removeItem("setEmailPromptDismissed");
    }
    if (apiWithAuth.endpoints.login.matchFulfilled(action)) {
      listenerApi.dispatch(clearNotification());
    }
    localStorage.removeItem("folderMappings");
  },
});

export default listenerMiddleware;
